export const clearSession = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("station");
    localStorage.removeItem("refreshToken");
};

export const logout = (navigate: (path: string) => void) => {
    clearSession();
    navigate("/login");
};

export const persistToken = (token: string) => {
    localStorage.setItem("authToken", token);
};

export const persistRefreshToken = (refreshToken: string) => {
    localStorage.setItem("refreshToken", refreshToken);
};

export const persistStation = (station: string) => {
    localStorage.setItem("station", station);
};

export const getToken = () => localStorage.getItem("authToken");

export const getRefreshToken = () => localStorage.getItem("refreshToken");
